import React from 'react'
import { Modal } from '@web/walter-ui-kit'
import Content from './Content'

interface Props {
    isOpen: boolean
    onClose: () => void
}

function UnfreezeModal({ isOpen, onClose }: Props) {
    return (
        <Modal
            type="dialog"
            withHeaderBorder={false}
            onClose={onClose}
            isOpen={isOpen}
            dataPointer="unfreeze_modal"
            size="xs"
        >
            <Content onClose={onClose} />
        </Modal>
    )
}

export default UnfreezeModal
